import React, { useEffect, useRef, useState } from "react";
import API from "../../Api/Api";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const AnnualMargin = ({ filters, selectedYear }) => {
  const { t } = useTranslation("common");
  const { user } = useSelector((state) => state.userReducer);
  const [data, setData] = useState([]);

  const rows = [
    {
      label: "General Margin Rate",
      value: data?.generalTxMarge ? data?.generalTxMarge.toFixed(2) : 0,
    },
    {
      label: "Spa Store Margin Rate",
      value: data?.totalMargins?.spa?.totalTxMarge
        ? data?.totalMargins?.spa?.totalTxMarge?.toFixed(2)
        : 0,
    },
    {
      label: "Swim Spa Store Margin Rate",
      value: data?.totalMargins?.swimSpa?.totalTxMarge
        ? data?.totalMargins?.swimSpa?.totalTxMarge?.toFixed(2)
        : 0,
    },
    {
      label: "Accessory Store Margin Rate",
      value: data?.totalMargins?.accessory?.totalTxMarge
        ? data?.totalMargins?.accessory?.totalTxMarge?.toFixed(2)
        : 0,
    },
    {
      label: "Spare Parts Store Margin Rate",
      value: data?.totalMargins?.sparePart?.totalTxMarge
        ? data?.totalMargins?.sparePart?.totalTxMarge?.toFixed(2)
        : 0,
    },
    {
      label: "Marketing Product Margin Rate",
      value: data?.totalMargins?.marketingProduct?.totalTxMarge
        ? data?.totalMargins?.markingProduct?.totalTxMarge?.toFixed(2)
        : 0,
    },
    {
      label: "Key Accounts Margin Rate",
      value: data?.totalMargins?.bigAccount?.totalTxMarge
        ? data?.totalMargins?.bigAccount?.totalTxMarge?.toFixed(2)
        : 0,
    },
  ];

  const abortControllerRef = useRef(null);

  const fetchData = async (signal) => {
    try {
      const params = {
        year: selectedYear,
        marque: user?.attributes?.marque?.data?.id,
      };

      Object.keys(filters)?.forEach((key) => {
        if (filters[key]) {
          params[key] = filters[key]?.code;
        }
      });

      const response = await API.get(`api/annual-margin`, {
        signal,
        params,
      });

      setData(response?.data);
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
        return;
      console.log(error);
    }
  };

  useEffect(() => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    fetchData(abortControllerRef.current.signal);
  }, [selectedYear, filters, user]);

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return (
    <div className="w-50">
      <div className="d-flex gap-4 w-100">
        <div className="w-100 flex-column d-flex gap-1">
          {rows.map(({ label, value }) => (
            <div className="d-flex justify-content-between gap-1">
              <span className="f16 py-2 px-4 text-lightBlack sBold f14 w70 bg-dimGrey">
                {t(`${label}`)}
              </span>
              <span className="f16 py-2 px-4 text-lightBlack sBold f14 w30 bg-dimGrey text-center">
                {value ?? 0}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnnualMargin;
